import { NO_DATA_MESSAGE, PersonHttpHelper } from '@usas/ui-web/utils/HttpHelper';

const postPersonNcsaOptIn = (postObj, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading...'
    };
    setState(newState);
    
    const url = `/PersonNcsaOptIn/Config`;
    PersonHttpHelper(url, 'POST', postObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

export default postPersonNcsaOptIn;
